<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-col cols="12">
      <transition name="slide">
        <b-card header="Lista de clientes">
          <b-row>
            <b-col cols="3">
              <b-form-group label="Filtros" label-class="font-weight-bold pt-0">
                <b-form-select
                  id="formSelect"
                  :options="optionsFilter"
                  v-model="selectedFilter"
                  @change="focus('filterInput')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Busca" label-class="font-weight-bold pt-0">
                <b-input-group size="md">
                  <b-form-input
                    v-model="filtro"
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                    @keyup.enter="retornaClientes(1)"
                    :disabled="!selectedFilter"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filtro" @click="cleanSearch()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-form-group label="Status" label-class="font-weight-bold pt-0">
              <b-form-radio-group
                v-model="selectedStatus"
                :options="optionsStatus"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                size="lg"
                @change="retornaClientes(1)"
              ></b-form-radio-group>
            </b-form-group>
          </b-row>

          <div>
            <b-row align-h="end">
              <b-col cols="12">
                <Pagination
                  :source="pagination"
                  @navigate="navigate"
                ></Pagination>
              </b-col>
            </b-row>
          </div>

          <b-table
            hover
            striped
            bordered
            stickyColumn
            responsive
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            head-variant="light"
            @row-clicked="abrirDetalheCliente"
          >
            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Carregando...</strong>
            </div>
            <template v-slot:cell(ativado)="data">
              <b-badge
                :variant="getBadge(data.item.ativado, data.item.islive)"
                >{{
                  data.item.islive == false
                    ? "Desinstalou"
                    : data.item.ativado == true
                    ? "Ativo"
                    : "Em espera"
                }}</b-badge
              >
            </template>
          </b-table>
          <div>
            <b-row align-h="end">
              <b-col cols="3" style="font-weight: bold">
                Total de registros: {{ this.totalRows }}
              </b-col>
            </b-row>
          </div>
        </b-card>
      </transition>
    </b-col>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

import Pagination from "../../assets/components/pagination.vue";

export default {
  name: "Clientes",
  components: { Loading, Pagination },
  data: () => {
    return {
      pagination: {},
      items: [],
      selectedStatus: null,
      optionsStatus: [
        { item: 1, name: "Todos" },
        { item: 2, name: "Ativos" },
        { item: 3, name: "Pendentes" },
      ],
      selectedFilter: null,
      optionsFilter: [
        { value: null, text: "Selecione uma opção de filtro" },
        { value: 1, text: "Nome" },
        { value: 2, text: "Sobrenome" },
        { value: 3, text: "CPF" },
      ],

      fields: [
        { key: "id", label: "ID" },
        { key: "nome", label: "Nome" },
        { key: "sobrenome", label: "Sobrenome" },
        { key: "cpf", label: "CPF" },
        { key: "sexo", label: "Sexo" },
        { key: "ativado", label: "Status" },
        { key: "dataRegistro", label: "Registro" },
      ],

      perPage: 12,
      paginationRange: 11,
      currentPage: 1,
      totalRows: 0,
      isLoading: false,
      filtro: "",
    };
  },

  methods: {
    getBadge(status, islive) {
      return islive == 0
        ? "danger"
        : status == 1
        ? "success"
        : status == 0
        ? "secondary"
        : "primary";
    },

    async abrirDetalheCliente(i) {
      localStorage.removeItem("idDetalheCliente");
      localStorage.removeItem("nomeDetalheCliente");
      localStorage.removeItem("sobrenomeDetalheCliente");

      localStorage.setItem("idDetalheCliente", i.id);
      localStorage.setItem("nomeDetalheCliente", i.nome);
      localStorage.setItem("sobrenomeDetalheCliente", i.sobrenome);

      this.$router.push(`/detalhe-cliente`);
    },

    focus(id) {
      document.getElementById(id).focus();
    },

    navigate(page) {
      this.retornaClientes(page);
    },

    cleanSearch() {
      this.focus("filterInput");
      (this.filtro = ""), this.retornaClientes(this.page);
    },

    validaStatus(index) {
      if (index == 2) return true;
      if (index == 3) return false;
    },

    buildParams(page, pageSize, companyId) {
      const params = {};
      if (page) params.page = page;
      if (pageSize) params.pageSize = pageSize;
      if (companyId) params.companyId = companyId;

      if (this.selectedFilter == 1) params.name = this.filtro;
      if (this.selectedFilter == 2) params.lastName = this.filtro;
      if (this.selectedFilter == 3) params.document = this.filtro;

      if (this.selectedStatus)
        params.isActive = this.validaStatus(this.selectedStatus);

      return params;
    },

    async retornaClientes(pagina) {
      const url = `${config.default.servidor}/gerencial/retorna-clientes`;

      const params = this.buildParams(
        pagina,
        this.perPage,
        localStorage.getItem("enterprise_id")
      );

      try {
        const response = await axios({
          url,
          method: "get",
          params,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.pagination = response.data;
          this.pagination.rowsPerPage = this.perPage;
          this.pagination.paginationRange = this.paginationRange;

          this.items = response.data.items;
          this.totalRows = response.data.records;
        }
      } catch (error) {
        console.log({ error });
        this.items = null;
        await this.$toasted.show("Nenhum registro encontrado!", {
          theme: "outline",
          position: "top-center",
          duration: 3000,
          icon: "warning",
          iconPack: "fontawesome",
        });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.retornaClientes(1);
    this.isLoading = false;
  },
};
</script>
<style scoped>
.col {
  text-align: right;
}
</style>
